import { DormantCampaignsPage } from 'app/pages/DormantCampaignsPage/Loadable';
import { DormantCampaignsViewPage } from 'app/pages/DormantCampaignsViewPage/Loadable';
import { DealerSettingsPage } from 'app/pages/DealerSettingsPage/Loadable';
import { DormantCampaignsLeadsPage } from 'app/pages/DormantCampaignsLeadsPage/Loadable';
import { GenerateTemplatesPage } from 'app/pages/GenerateTemplatesPage/Loadable';
import { WorkflowsPage } from 'app/pages/WorkflowsPage/Loadable';
import { WorkflowDetailsPage } from 'app/pages/WorkflowDetailsPage/Loadable';
import { MapTemplatesPage } from 'app/pages/MapTemplatesPage/Loadable';
import { UploadDataGridPage } from 'app/pages/UploadDataGridPage/Loadable';
import { UploadLeadsPage } from 'app/pages/UploadDataUploadPage/Loadable';
import { UploadDataDetailsPage } from 'app/pages/UploadDataDetailsPage/Loadable';
import { UploadDataLeadConflictPage } from 'app/pages/UploadDataLeadConflictPage/Loadable';
import { MyautoiqCampaignsPage } from 'app/pages/MyautoiqCampaignsPage/Loadable';
import { MyautoiqCampaignsViewPage } from 'app/pages/MyautoiqCampaignsViewPage/Loadable';
import { MyautoiqCampaignsLeadsPage } from 'app/pages/MyautoiqCampaignsLeadsPage/Loadable';
import { MyautoiqCampaignsLeadsDetailsPage } from 'app/pages/MyautoiqCampaignsLeadsDetailsPage/Loadable';
import { DataPullRecordsPage } from 'app/pages/DataPullRecordsPage/Loadable';
import { DealerInventoriesPage } from 'app/pages/DealerInventoriesPage/Loadable';
import { DealerInventoriesDetailsPage } from 'app/pages/DealerInventoriesDetailsPage/Loadable';
import { InventoryDetailsPage } from 'app/pages/InventoryDetailsPage/Loadable';
import { NurturingCandidatesPage } from 'app/pages/NurturingCandidatesPage/Loadable';
import { NurturingCandidatesViewPage } from 'app/pages/NurturingCandidatesViewPage/Loadable';
import { NurturingCandidatesSegmentsPage } from 'app/pages/NurturingCandidatesSegmentsPage/Loadable';
import { DormantCampaignsLeadsFilterPage } from 'app/pages/DormantCampaignsLeadsFilterPage/Loadable';
import { DashboardsPage } from 'app/pages/DashboardsPage/Loadable';
import { DealerDashboardPage } from 'app/pages/AllDealershipGridPage/Loadable';
import { CrmMessageDetailsPage } from 'app/pages/CrmMessageDetailsPage/Loadable';
import { EmailsGridPage } from 'app/pages/EmailsGridPage/Loadable';
import { EmailTemplatesCreateEditPage } from 'app/pages/EmailCreateEditPage/Loadable';
import { SendEmailPage } from 'app/pages/SendEmailPage/Loadable';
import { LeadListPage } from 'app/pages/LeadListPage/Loadable';
import { LeadNurturingTasksPage } from 'app/pages/LeadNurturingTasksPage/Loadable';
import { SendingCalendarPage } from 'app/pages/SendingCalendarPage/Loadable';
import { SystemInfoPage } from 'app/pages/SystemInfoPage/Loadable';
import { CampaignPage } from 'app/pages/CampaignPage/Loadable';
import { AutomationGridPage } from 'app/pages/AutomationGridPage/Loadable';
import { AutomationDefinitionPage } from 'app/pages/AutomationDefinitionPage/Loadable';
import { NotAuthorizedPage } from 'app/components/NotAuthorizedPage/Loadable';
import { GenerateEmailFromTemplatesPage } from 'app/pages/GenerateEmailFromTemplatesPage';
import { SegmentPage } from 'app/pages/SegmentPage/Loadable';
import { NurturingHistoryPage } from 'app/pages/NurturingHistoryPage/Loadable';
import { CRMDataDumpRequestsPage } from 'app/pages/CRMDataDumpRequestsPage/Loadable';
import { SalesDemoPage } from "app/pages/SalesPortalPage/LayoutV1/Loadable";
import { HomePage } from "app/pages/HomePage/Loadable";
import { DealershipGroupDashboardsPage } from "app/pages/DealershipGroupDashboardsPage/Loadable";
import UserManagementPage from 'app/pages/UserManagementPage';
import RoleManagementPage from 'app/pages/RoleManagementPage';
import ContentManagementPage from 'app/pages/ContentManagementPage';
import RunLogsPage from 'app/pages/RunLogsPage';
import MiaChatPage from 'app/pages/MiaChatPage';
import ScorecardPage from 'app/pages/ScorecardPage';
import UnsoldPage from 'app/pages/UnsoldPage';

// NewAIAvatarLayout components
import { HomePage as AIAvatarHomePage } from 'app/NewAIAvatarLayout/features/home/HomePage';
import MeasurePage from 'app/NewAIAvatarLayout/features/MeasurePage';
import { TargetPage } from 'app/NewAIAvatarLayout/features/TargetPage/TargetPage';
import { GeneratePage } from 'app/NewAIAvatarLayout/features/GeneratePage/GeneratePage';
import { AnalyzePage } from 'app/NewAIAvatarLayout/features/AnalyzePage/AnalyzePage';
import ConfigurePage from 'app/NewAIAvatarLayout/features/ConfigurePage/ConfigurePage';
import ContentPage from 'app/NewAIAvatarLayout/features/ContentPage/ContentPage';
import { SettingsPage } from 'app/NewAIAvatarLayout/features/SettingsPage/SettingsPage';
import { AdminPage } from 'app/NewAIAvatarLayout/features/AdminPage/AdminPage';
import { FeedbackPage } from 'app/NewAIAvatarLayout/features/FeedbackPage/FeedbackPage';

export const routesMap = {
    DormantCampaignsLeadsPage: DormantCampaignsLeadsPage,
    CrmMessageDetailsPage: CrmMessageDetailsPage,
    DormantCampaignsPage: DormantCampaignsPage,
    DormantCampaignsLeadsFilterPage: DormantCampaignsLeadsFilterPage,
    DormantCampaignsViewPage: DormantCampaignsViewPage,
    DealerSettingsPage: DealerSettingsPage,
    WorkflowsPage: WorkflowsPage,
    WorkflowDetailsPage: WorkflowDetailsPage,
    GenerateTemplatesPage: GenerateTemplatesPage,
    GenerateEmailFromTemplatesPage: GenerateEmailFromTemplatesPage,
    MapTemplatesPage: MapTemplatesPage,
    UploadDataGridPage: UploadDataGridPage,
    UploadLeadsPage: UploadLeadsPage,
    UploadDataDetailsPage: UploadDataDetailsPage,
    UploadDataLeadConflictPage: UploadDataLeadConflictPage,
    MyautoiqCampaignsPage: MyautoiqCampaignsPage,
    MyautoiqCampaignsViewPage: MyautoiqCampaignsViewPage,
    MyautoiqCampaignsLeadsPage: MyautoiqCampaignsLeadsPage,
    MyautoiqCampaignsLeadsDetailsPage: MyautoiqCampaignsLeadsDetailsPage,
    DataPullRecordsPage: DataPullRecordsPage,
    CRMDataDumpRequestsPage: CRMDataDumpRequestsPage,
    DealerInventoriesPage: DealerInventoriesPage,
    DealerInventoriesDetailsPage: DealerInventoriesDetailsPage,
    InventoryDetailsPage: InventoryDetailsPage,
    NurturingCandidatesPage: NurturingCandidatesPage,
    NurturingCandidatesViewPage: NurturingCandidatesViewPage,
    NurturingCandidatesSegmentsPage: NurturingCandidatesSegmentsPage,
    DashboardsPage: DashboardsPage,
    DealershipGroupDashboardsPage: DealershipGroupDashboardsPage,
    SegmentPage: SegmentPage,
    EmailsGridPage: EmailsGridPage,
    SendEmailPage: SendEmailPage,
    DealerDashboardPage: DealerDashboardPage,
    HomePage: HomePage,
    EmailTemplatesCreateEditPage: EmailTemplatesCreateEditPage,
    LeadListPage: LeadListPage,
    LeadNurturingTasksPage: LeadNurturingTasksPage,
    SendingCalendarPage: SendingCalendarPage,
    UserManagementPage: UserManagementPage,
    RoleManagementPage: RoleManagementPage,
    ContentManagementPage: ContentManagementPage,
    SystemInfoPage: SystemInfoPage,
    CampaignPage: CampaignPage,
    AutomationGridPage: AutomationGridPage,
    AutomationDefinitionPage: AutomationDefinitionPage,
    NurturingHistoryPage: NurturingHistoryPage,
    SalesDemoPage: SalesDemoPage,
    SalesPortalPageV2: SalesDemoPage, // Alias for backend compatibility
    NotAuthorizedPage: NotAuthorizedPage,
    RunLogsPage: RunLogsPage,
    MiaChatPage: MiaChatPage,
    // NewAIAvatarLayout routes
    AIAvatarHomePage: AIAvatarHomePage,
    AIAvatarMeasurePage: MeasurePage,
    AIAvatarTargetPage: TargetPage,
    AIAvatarGeneratePage: GeneratePage,
    AIAvatarAnalyzePage: AnalyzePage,
    AIAvatarConfigurePage: ConfigurePage,
    AIAvatarContentPage: ContentPage,
    AIAvatarSettingsPage: SettingsPage,
    AIAvatarAdminPage: AdminPage,
    AIAvatarFeedbackPage: FeedbackPage,
    AIAvatarScorecardPage: ScorecardPage,
    AIAvatarUnsoldPage: UnsoldPage,
}

export const roleToRouteMap = {
    maiq_super_admin: "/all-dealership-view",
    super_user: "/all-dealership-view",
    maiq_tech_user: "/all-dealership-view",
    dealership_group_executive: "/sales-demo",
    dealership_executive: "/sales-demo",
    maiq_sales_user: "/sales-demo",
    sales_person: "/sales-demo",
    maiq_performance_manager: "/sales-demo",
    beta_maiq_performance_manager: "/ai-avatar-layout",
    ai_maiq_sales: "/ai-avatar-layout",
    maiq_content_manager: "/ai-avatar-layout",
};